window.Ziggy = require('../ziggy.js').Ziggy;
window.route = require('../../../../node_modules/ziggy/dist/js/route');
